import React from "react";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import TableFooter from "@mui/material/TableFooter";

import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";

import ClearIcon from "@mui/icons-material/Clear";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import { setError } from "../../reducers/appSlice";
import api from "../../service/api";
import Page from "../../layout/Page";

import Modal from "../../components/Modal";
// Buscador de Organismos
import BuscadorOrganismo from "../../commons/BuscadorOrganismo";
import VisorPdf from "../../components/Visorpdf";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";



const TabContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    paddingRight: theme.spacing(10),
    paddingLeft: theme.spacing(10),
  },
}));

const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const leyendaTema =
  "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

const TableCellHead = styled(TableCell)(({ theme }) => ({
  color: "#3c4b64",
}));

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const MovimientoExpediente = (props) => {
  var validationSchema = Yup.object().shape({
    fecha: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .min("01/01/1992", "Fecha no válida")
      .max(new Date(), "Fecha no válida")
  });

  const [selected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [codigoOrganismo, setCodigoOrganismo] = useState(0);
  const [descripcionOrganismo, setDescripcionOrganismo] = useState("");
  const [fecha, setFecha] = useState("");

  const [asunto, setAsunto] = useState("");
  const [folios, setFolios] = useState("");
  const [foliosAux, setFoliosAux] = useState("");
  const [numero, setNumero] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [tramiteNoEncontrado, setTramiteNoEncontrado] = useState(true);
  const [tramiteId, setTramiteId] = useState(0);
  const [expedientes, setExpedientes] = useState([]);
  const [sinFolio, setSinFolio] = useState(true);
  const [resultado, setResultado] = useState("");
  const [openResultado, setOpenResultado] = React.useState(false);

  const [openDocumento, setOpenDocumento] = useState(false);
  const [documento, setDocumento] = useState("");

  const [buscandoOrganismo, setBuscandoOrganismo] = useState(
    false
  );
  const [textoNuevoCodigo, settextoNuevoCodigo] = useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCloseDocument = () => {
    setOpenDocumento(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCloseResultado = () => {
    setCodigoOrganismo(0);
    setDescripcionOrganismo("");
    setAsunto("");
    setFolios("");
    setNumero("");
    setFecha("");
    setObservaciones("");
    setTramiteNoEncontrado(true);
    setTramiteId(0);
    setExpedientes([]);
    formik.resetForm();
    formik2.resetForm();
    setOpenResultado(false);
  };

  const date = new Date();

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  function formatDateGrilla(date) {
    if (!date) return "";
    const [yyyy, mm, dd] = date.split("-");
    return `${dd}/${mm}/${yyyy}`;
  }

  const formik = useFormik({
    initialValues: {
      id_tramite: props.id,
      organismo: "",
      codigoOrganismo: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => { },
    onReset: () => { },
  });

  const formik2 = useFormik({
    initialValues: {
      nroExpediente: "",
      asuntos: "",
      folios: "",
      fecha: formatDate(date),
      observaciones: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => { },
    onReset: () => { },
  });

  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Registrar movimiento de expedientes", ruta: "" },
  ];

  const realizarMovimientoMasivo = () => {
    setSubmitting(true);
    
    const fechaIngresada = new Date(formik2.values.fecha);
    const fechaMinima = new Date("1992-01-01");
    const hoy = new Date();
    const fechaLimite = new Date();
    fechaLimite.setDate(hoy.getDate() - 45);

    if (!formik2.values.fecha || isNaN(fechaIngresada.getTime())) {
      dispatch(setError("Debe ingresar una fecha válida."));
      setSubmitting(false);
      return;
    }

    if (fechaIngresada <= fechaMinima) {
      dispatch(setError("La fecha debe ser posterior al 01/01/1992."));
      setSubmitting(false);
      return;
    }

    if (fechaIngresada < fechaLimite) {
      dispatch(
        setError(
          "La fecha no puede ser anterior a 45 días antes de la fecha actual."
        )
      );
      setSubmitting(false);
      return;
    }

    if (fechaIngresada > hoy) {
      dispatch(setError("La fecha no puede ser mayor a la fecha actual."));
      setSubmitting(false);
      return;
    }
    
    if (
      expedientes.length !== 0 &&
      codigoOrganismo !== 0 &&
      codigoOrganismo !== "" &&
      codigoOrganismo !== null
    ) {
      let expedientesSeleccionados = [];

      for (let index = 0; index < expedientes.length; index++) {
        const expediente = expedientes[index];
        let datoExpediente = {
          TRA_ID: expediente.id,
          CANT_FOLIOS: expediente.folios,
          OBSERVACION: expediente.observaciones,
        };
        expedientesSeleccionados.push(datoExpediente);
      }

      let datos = {
        destino: codigoOrganismo,
        destinoDesc: descripcionOrganismo,
        fecha: formik2.values.fecha,
        tramites: expedientesSeleccionados,
      };

      api
        .guardarMovimientoExpedientes(datos)
        .then((res) => {
          //console.log("res: " + res.data.resultado);
          verResultado(res.data.resultado);
          setSubmitting(false);
          if (res.data.documento !== "") {
            setDocumento(res.data.documento);
            //console.log(documento);
            setOpenDocumento(true);
          }
        })
        .catch((e) => {
          dispatch(setError(e.response.data.error));
        })
        .finally(() => setSubmitting(false));
    } else {
      if (expedientes.length === 0 || codigoOrganismo === 0) {
        dispatch(
          setError(
            "Para poder realizar los movimientos debés ingresar el organismo de destino y agregar el o los expedientes en la grilla."
          )
        );
        setSubmitting(false);
      } else {
        if (expedientes.length === 0) {
          dispatch(setError("Debe agregar los expedientes en la grilla."));
          setSubmitting(false);
        } else {
          dispatch(setError("Debe seleccionar el organismo de destino."));
          setSubmitting(false);
        }
      }
    }
  };



  const verResultado = (resultado) => {
    setResultado(resultado);
    setOpenResultado(true);
    settextoNuevoCodigo('');
  };

  const reiniciarFormulario = () => {
    setCodigoOrganismo(0);
    setDescripcionOrganismo("");
    setAsunto("");
    setFolios("");
    setNumero("");
    setFecha("");
    setObservaciones("");
    setTramiteNoEncontrado(true);
    setTramiteId(0);
    setExpedientes([]);
    formik.resetForm();
    formik2.resetForm();
    settextoNuevoCodigo('');
  };


  const handleAgregarATablaTramite = (tramiteId) => {
    if (tramiteId !== 0) {
      if (sinFolio === false && (folios === "0" || folios === "")) {
        dispatch(setError("Debe ingresar el número de folios."));
      } else {
        if (expedientes.find((expediente) => expediente.id === tramiteId)) {
          dispatch(
            setError(
              "El número de expediente ingresado ya se encuentra en la grilla."
            )
          );
        } else {          
          if (sinFolio === false  && (Number(folios) < Number(foliosAux))) {
            dispatch(
              setError(
                `La cantidad de folios no puede ser menor a ${foliosAux}.`
              )
            );            
            return;
          }

          let datoExpediente = {
            id: tramiteId,
            numero: numero,
            asunto: asunto,
            folios: folios,
            observaciones: observaciones,
          };

          setExpedientes([datoExpediente, ...expedientes]);        
          setAsunto("");
          setFolios("");
          setNumero("");
          setTramiteNoEncontrado(true);
          setSinFolio(true);

          formik2.setFieldValue("nroExpediente", "");
          document.getElementById("nroExpediente").focus();
        }
      }
    }
  };


  const handleQuitarATablaTramite = (index) => {
    let expedientesAux = [...expedientes];
    expedientesAux.splice(index, 1);
    setExpedientes([...expedientesAux]);
  };

  const handleChangeTextField2 = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      setFolios(event.target.value);
      formik2.setFieldValue(event.target.id, event.target.value);
    }
  };

  const handleChangeCodigoOrganismo = (event) => {
    if (
      formik.values.organismo !== "" &&
      formik.values.organismo !== null
    )
      handleOrganismo();

    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("codigoOrganismo", event.target.value);
    setCodigoOrganismo(event.target.value);
  };

  const handleCodigoOrganismo = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarOrganismoPorCodigo(event.target.value);
      }
      setTimeout(function foco() {
        document.getElementById("nroExpediente").focus();
      }, 500);
    } else if (
      event.type === "blur" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      //buscarOrganismoPorCodigo(event.target.value);
      document.getElementById("nroExpediente").focus();
    }
  };

  const handleOrganismo = (organismo = null) => {
    if (organismo !== null) {
      formik.setFieldValue("codigoOrganismo", organismo.id);
      formik.setFieldValue(
        "organismo",
        organismo.descOrgCompleta
      );
      setCodigoOrganismo(organismo.id);
      setDescripcionOrganismo(organismo.descOrgCompleta);
    } else {
      formik.setFieldValue("codigoOrganismo", "");
      formik.setFieldValue("organismo", "");
      setCodigoOrganismo(0);
      setDescripcionOrganismo("");
    }
  };

  const handleNumeroTramite = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarTramite(event.target.value);
        setTimeout(function foco() {
          if (document.getElementById("folios").value === 0 && document.getElementById("folios").value === "") {
            document.getElementById("observaciones").focus();
          } else {
            document.getElementById("folios").focus();
          }
        }, 400);
      } else {
        setAsunto("");
        setFolios("");
        setNumero("");
        setTramiteNoEncontrado(true);
        setSinFolio(true);
      }
    } else if (
      event.type === "blur" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarTramite(event.target.value);
      setTimeout(function foco2() {
        if (document.getElementById("folios").value === 0 && document.getElementById("folios").value === "") {
          document.getElementById("observaciones").focus();
        } else {
          document.getElementById("folios").focus();
        }
      }, 400);
    } else {
      setAsunto("");
      setFolios("");
      setNumero("");
      setTramiteNoEncontrado(true);
      setSinFolio(true);
    }
  };

  const handleChangeNumeroTramite = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik2.setFieldValue(event.target.id, event.target.value);
    }
  };

  const handleChangeObservacion = (event) => {
    formik2.setFieldValue(event.target.id, event.target.value);
    setObservaciones(event.target.value);
  };

  const buscarTramite = (nro) => {
    if (nro !== "" && nro !== null) {
      let filtro = {
        nroExpediente: nro
      };

      api
        .consultaExpediente(filtro)
        .then((res) => {
          setAsunto(res.data[0].asunto);
          if (res.data[0].soporte === "DIGITAL") {
            setFolios(0);
            setSinFolio(true);            
          } else {
            setSinFolio(false);
            setFolios(res.data[0].cant_folios);
            setFoliosAux(res.data[0].cant_folios);
          }
          setTramiteId(res.data[0].id);
          setTramiteNoEncontrado(false);
          setNumero(nro);
        })
        .catch((e) => {
          dispatch(setError("El expediente que estás buscando no existe o no cumple con las condiciones para registrar el movimiento."));
          setTramiteId(0);
          setAsunto("");
          setFolios("");
          formik2.setFieldValue("nroExpediente", "");
          setNumero("");
          setTramiteNoEncontrado(true);
          setSinFolio(true);
        });
    } else {
      setTramiteId(0);
      setAsunto("");
      setFolios("");
      formik2.setFieldValue("nroExpediente", "");
      setNumero("");
      setTramiteNoEncontrado(true);
      setSinFolio(true);
    }
  };


  const buscarOrganismoPorCodigo = (codigoOrganismo) => {
    setBuscandoOrganismo(true);
    api
      .buscarOrganismoUltimo({
        id: codigoOrganismo,
        // descripcion: "",
        // alta: "N",
        // accion: "alta",
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          handleOrganismo(res.data[0]);
          if(codigoOrganismo !== res.data[0].id)
          { 
            settextoNuevoCodigo('Hubo cambios de orgánica y el organismo "'+codigoOrganismo+'" fue reemplazado por "'+res.data[0].id+'"');
          }else{
            settextoNuevoCodigo('');
          }
        } else {
          handleOrganismo();
          dispatch(setError("No se encontró el organismo."));
        }
      })
      .catch((e) => {
        handleOrganismo();
        dispatch(setError("Error al buscar el organismo."));
      })
      .finally(() => {
        setBuscandoOrganismo(false);
      });
  };

  useEffect(() => { }, []);

  return (
    <Page breadcrumbs={breadcrumbs}>
      <TabContainer>
        <form
          id="formBusquedaOrganismo"
          name="formBusquedaOrganismo"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Row container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="cuerpo">
                Organismo de destino de los expedientes
              </Typography>
            </Grid>

            <Grid item lg={2} xs={12}>
              <TextField
                id="codigoOrganismo"
                name="codigoOrganismo"
                label="Código"
                variant="outlined"
                size="small"
                fullWidth
                autoFocus
                value={formik.values.codigoOrganismo}
                onChange={
                  (handleChangeCodigoOrganismo)
                }
                onKeyDown={handleCodigoOrganismo}
                onBlur={handleCodigoOrganismo}
                error={
                  formik.touched.codigoOrganismo &&
                  Boolean(formik.errors.codigoOrganismo)
                }
                helperText={
                  formik.touched.codigoOrganismo &&
                  formik.errors.codigoOrganismo
                }
              />
              <Typography
                variant="aclaracion"
                sx={{
                  display: {
                    xs: "inline",
                    sm: "inline",
                    md: "inline",
                    lg: "none",
                  },
                }}
              >
                {leyendaTema}
              </Typography>
            </Grid>
            <Grid item lg={10} xs={12}>
              <Box display="flex" flexDirection="row">
                <TextField
                  id="organismo"
                  name="organismo"
                  label="Organismo"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.organismo}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.organismo &&
                    Boolean(formik.errors.organismo)
                  }
                  helperText={
                    formik.touched.organismo &&
                    formik.errors.organismo
                  }
                  disabled
                />
                {buscandoOrganismo ? (
                  <CircularProgress
                    color="primary"
                    size={20}
                    sx={{ margin: 1 }}
                  />
                ) : (
                  <BuscadorOrganismo
                    resultado={handleOrganismo}
                    activo={"S"}
                    alta={"S"}
                    accion="alta"
                  />
                )}
              </Box>
            </Grid>
            <Grid container>
              <Typography
                variant="aclaracion"
                sx={{
                  ml: 2,
                  display: {
                    xs: "none",
                    sm: "none",
                    md: "none",
                    lg: "inline",
                  },
                }}
              >
                {leyendaTema}
              </Typography>
            </Grid>
            <DialogActions sx={{ justifyContent: "flex-start" }}>
            <Typography
              variant="aclaracion"
              sx={{
                ml: 1,
                display: "inline",
                color: "#D9680B",
              }}
            >
              {textoNuevoCodigo}
            </Typography>
          </DialogActions> 
          </Row>
          <Row container spacing={1}>
            <Grid item lg={2} xs={12}>
              <FormControl
                variant="outlined"
                size="small"
                error={
                  formik2.touched.fecha && Boolean(formik2.errors.fecha)
                }
                fullWidth
              >
                <TextField
                  id="fecha"
                  name="fecha"
                  type="date"
                  value={formik2.values.fecha}
                  label="Fecha del movimiento"
                  variant="outlined"
                  size="small"
                  onChange={formik2.handleChange}
                  InputLabelProps={{ shrink: true }}
                //disabled={sinFolio}
                />
                <FormHelperText>
                  {formik2.touched.fecha && formik2.errors.fecha}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Row>
        </form>
        <br></br>
        <form
          id="formBusquedaExpediente"
          name="formBusquedaExpediente"
          onSubmit={formik2.handleSubmit}
          onReset={formik2.handleReset}
          noValidate
          autoComplete="off"
        >
          <Row container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="cuerpo">
                Expedientes a realizar el movimiento
              </Typography>
            </Grid>
            <Grid item xs={12} lg={2}>
              <TextField
                id="nroExpediente"
                name="nroExpediente"
                label="Número"
                variant="outlined"
                size="small"
                inputProps={{ maxLength: 8 }}
                fullWidth
                value={formik2.values.nroExpediente}
                onChange={handleChangeNumeroTramite}
                onBlur={handleNumeroTramite}
                onKeyDown={handleNumeroTramite}
                error={
                  formik2.touched.nroExpediente &&
                  Boolean(formik2.errors.nroExpediente)
                }
                helperText={
                  formik2.touched.nroExpediente && formik2.errors.nroExpediente
                }
              />
            </Grid>
            <Grid item xs={12} lg={8}>
              <TextField
                id="asunto"
                name="asunto"
                variant="outlined"
                size="small"
                label="Asunto"
                fullWidth
                value={asunto}
                onChange={formik2.handleChange}
                error={formik2.touched.asunto && Boolean(formik2.errors.asunto)}
                helperText={formik2.touched.asunto && formik2.errors.asunto}
                disabled
              />
            </Grid>


            <Grid item xs={12} lg={2}>
              <Box display="flex" flexDirection="row">
                <TextField
                  id="folios"
                  name="folios"
                  label="Folios"
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 4 }}
                  fullWidth
                  value={folios}
                  onChange={handleChangeTextField2}
                  error={
                    formik2.touched.folios && Boolean(formik2.errors.folios)
                  }
                  helperText={formik2.touched.folios && formik2.errors.folios}
                  disabled={sinFolio}
                />
                <IconButton
                  title="Seleccionar"
                  size="small"
                  color="primary"
                  onClick={() => handleAgregarATablaTramite(tramiteId)}
                  disabled={tramiteNoEncontrado}
                >
                  <DoneOutlineRounded fontSize="small" />
                </IconButton>
              </Box>
            </Grid>
          </Row>
          <Row container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <TextField
                id="observaciones"
                name="observaciones"
                label="Observaciones"
                variant="outlined"
                size="small"
                multiline
                rows={3}
                fullWidth
                inputProps={{ maxLength: 150 }}
                value={observaciones}
                onChange={(handleChangeObservacion)}
                error={
                  formik2.touched.observaciones &&
                  Boolean(formik2.errors.observaciones)
                }
                helperText={
                  (formik2.touched.observaciones && formik2.errors.observaciones) || "Máximo 150 caracteres"
                }
              />
            </Grid>
          </Row>
        </form>
        <br></br>
        <TableContainer>
          <Table
            aria-label="tabla movimientos"
            sx={{ border: "1px solid #dee2e6" }}
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCellHead padding="normal">
                  <b>Expediente</b>
                </TableCellHead>
                <TableCellHead padding="normal">
                  <b>Asunto</b>
                </TableCellHead>
                <TableCellHead align="right" padding="normal">
                  <b>Folios</b>
                </TableCellHead>
                <TableCellHead padding="normal">
                  <b>Observaciones</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Acciones</b>
                </TableCellHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {expedientes.map((expediente, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={
                      index % 2 === 0
                        ? { backgroundColor: "#f2f2f2" }
                        : { backgroundColor: "#fff" }
                    }
                  >
                    <TableCell align="left" width="100">
                      {expediente.numero}
                    </TableCell>
                    <TableCell align="left" width="400">
                      {expediente.asunto}
                    </TableCell>
                    <TableCell align="right" width="100">
                      {expediente.folios}
                    </TableCell>
                    <TableCell width="300">
                      {expediente.observaciones}
                    </TableCell>
                    <TableCell align="center" width="100">
                      <>
                        <IconButton
                          title="Quitar"
                          size="small"
                          onClick={() => handleQuitarATablaTramite(index)}
                        >
                          <RemoveCircleOutlineOutlinedIcon fontSize="small" />
                        </IconButton>
                      </>
                    </TableCell>
                  </TableRow>
                );
              })}
              {expedientes.length === 0 ? (
                <TableRow>
                  <TableCell colSpan="6" align="center">
                    <Typography variant="aclaracion">
                      Sin expedientes ingresados
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                ""
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    { label: "Todos", value: expedientes.length },
                  ]}
                  count={expedientes.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  selected={selected}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>       
          <Grid container sx={{ display: { xs: "none", sm: "block" } }}>
            <Grid item xs={12} align="right" sx={{ marginBottom: 2 }}>
              <Button
                variant="plata"
                onClick={() => reiniciarFormulario()}
                endIcon={<ClearIcon />}
                sx={{ m: 1 }}
              >
                {"Cancelar"}
              </Button>
              <Button
                sx={{ m: 1 }}
                variant="verde"
                color="primary"
                type="button"
                disabled={submitting}
                endIcon={<DoneOutlineRounded />}
                onClick={() => realizarMovimientoMasivo()}
              >
                {submitting ? "Confirmando..." : "Confirmar"}
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              align="right"
              sx={{ display: { xs: "block", md: "none" } }}
            >
              <IconButton color="primary" onClick={() => reiniciarFormulario()} title="Cancelar">
                <ClearIcon />
              </IconButton>{" "}
              <IconButton
                color="primary"
                type="button"
                disabled={submitting}
                title="Confirmar"
                onClick={() => realizarMovimientoMasivo()}
              >
                <DoneOutlineRounded />
              </IconButton>
            </Grid>

          </Grid>
          <Grid container sx={{ display: { xs: "block", sm: "none" } }} align="right">
            <IconButton color="primary" onClick={() => reiniciarFormulario()} title="Cancelar">
              <ClearIcon />
            </IconButton>{" "}
            <IconButton
              color="primary"
              onClick={() => realizarMovimientoMasivo()}
              disabled={submitting}
              title="Confirmar"
            >
              <DoneOutlineRounded />
            </IconButton>
          </Grid>
        </TableContainer>
      </TabContainer>
      <Modal open={openResultado} handleClose={handleCloseResultado} size="sm">
        {resultado.split("\n").map((i, key) => {
          return (
            <Typography variant="cuerpo" paragraph key={key}>
              {i}
            </Typography>
          );
        })}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button
            sx={{ m: 1 }}
            variant="plata"
            onClick={handleCloseResultado}
            endIcon={<ClearIcon />}
          >
            {"Cerrar"}
          </Button>
        </Box>
      </Modal>


      <Modal open={openDocumento} handleClose={handleCloseDocument} closeButton>
        <VisorPdf url={"data:application/octet-stream;base64," + documento} />
      </Modal>


    </Page >
  );
};

export default MovimientoExpediente;